import { downloadCsv } from "../../../utils/downloadCsv";
import { ToastService } from "../../../utils/toastify";
import { languageService } from "../../../Language/language.service";

export const LineInspectionCSVMethod = (csvData, dateRange) => {
  if (csvData && csvData.length > 0) {
    let updatedCSVData = csvData.map((e) => {
      let newObj = {};
      for (let key in e) {
        newObj[key] = languageService(e[key]);
      }
      return newObj;
    });
    downloadCsv(
      updatedCSVData,
      document,
      dateRange ? `LineInspectionSummary-${dateRange}` : `LineInspectionSummary-${new Date().toISOString().split("T")[0]}`,
      "completed",
      null,
      dateRange ? `Report Period: ${dateRange}` : null,
    );
  } else {
    ToastService.Error("Error:", `${languageService("No Line Inspection Data Found!")}`);
  }
};
export const AssetInspectionCSVMethod = (csvData, dateRange) => {
  if (csvData && csvData.length > 0) {
    let updatedCSVData = csvData.map((e) => {
      let newObj = {};
      for (let key in e) {
        newObj[key] = languageService(e[key]);
      }
      return newObj;
    });
    downloadCsv(
      updatedCSVData,
      document,
      dateRange ? `AssetInspectionSummary-${dateRange}` : `AssetInspectionSummary-${new Date().toISOString().split("T")[0]}`,
      "completed",
      null,
      dateRange ? `Report Period: ${dateRange}` : null,
    );
  } else {
    ToastService.Error("Error:", `${languageService("No Asset Data Found!")}`);
  }
};



// WEBPACK FOOTER //
// ./src/components/Reports/Timps/CSVMethods.js